import { tokens } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  height: 100vh;
  width: 100%;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0 ${tokens.spacing.horizontalLarge} 100px;
`

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 400px;
  flex: 1;
  width: 100%;
  gap: ${tokens.spacing.verticalXsmall};

  @media (max-width: ${tokens.breakpoints.tablet}px) {
    max-width: 100%;
  }
`

export const WrapperEmailAnswerIcon = styled.div`
  width: 100%;
  min-height: 250px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    display: none;
  }
`

export const WrapperBackButton = styled.div`
  position: absolute;
  top: 16px;
  left: 16px;
`
